export const BLACK_SILICON = 'blacksilicone';
export const COLORLESS_SILICON = 'colorlesssilicone';
export const SILICON_TAPE = 'siliconetape';

const glassJointTypes = [BLACK_SILICON, COLORLESS_SILICON, SILICON_TAPE];

export default glassJointTypes;
